import api from './api.js';

export const gradeService = {
  // Get my grades (student)
  getMyGrades: (params = {}) => api.get('/grading/my-grades', { params }),
  
  // Get student grades (teacher/parent)
  getStudentGrades: (studentId, params = {}) => 
    api.get(`/grading/student/${studentId}/grades`, { params }),
  
  // Get class grades (teacher only)
  getClassGrades: (classId, params = {}) => 
    api.get(`/grading/class/${classId}/grades`, { params }),
  
  // Get grades by subject
  getGradesBySubject: (subjectId, params = {}) => 
    api.get(`/grading/subject/${subjectId}/grades`, { params }),
  
  // Get grades by term
  getGradesByTerm: (termId, params = {}) => 
    api.get(`/grading/term/${termId}/grades`, { params }),
  
  // Get report card
  getReportCard: (studentId, termId) => 
    api.get(`/grading/report-card/${studentId}/${termId}`),
  
  // Get my report cards (student)
  getMyReportCards: (params = {}) => api.get('/grading/my-report-cards', { params }),
  
  // Get children's report cards (parent)
  getChildrenReportCards: (params = {}) => api.get('/grading/children-report-cards', { params }),
  
  // Create grade entry (teacher only)
  createGrade: (data) => api.post('/grading/grades', data),
  
  // Update grade (teacher only)
  updateGrade: (gradeId, data) => api.put(`/grading/grades/${gradeId}`, data),
  
  // Delete grade (teacher only)
  deleteGrade: (gradeId) => api.delete(`/grading/grades/${gradeId}`),
  
  // Bulk create grades (teacher only)
  bulkCreateGrades: (data) => api.post('/grading/bulk-grades', data),
  
  // Get grade statistics
  getGradeStats: (params = {}) => api.get('/grading/stats', { params }),
  
  // Get student performance trends
  getPerformanceTrends: (studentId, params = {}) => 
    api.get(`/grading/student/${studentId}/trends`, { params }),
  
  // Get class performance summary (teacher only)
  getClassPerformance: (classId, params = {}) => 
    api.get(`/grading/class/${classId}/performance`, { params }),
  
  // Get subject performance summary
  getSubjectPerformance: (subjectId, params = {}) => 
    api.get(`/grading/subject/${subjectId}/performance`, { params }),
  
  // Export grades (teacher only)
  exportGrades: (params = {}) => api.get('/grading/export', { 
    params, 
    responseType: 'blob' 
  }),
  
  // Export report card (PDF)
  exportReportCard: (studentId, termId) => 
    api.get(`/grading/report-card/${studentId}/${termId}/export`, { 
      responseType: 'blob' 
    }),
  
  // Get grade categories
  getGradeCategories: () => api.get('/grading/categories'),
  
  // Get grading scales
  getGradingScales: () => api.get('/grading/scales'),
  
  // Calculate GPA
  calculateGPA: (studentId, params = {}) => 
    api.get(`/grading/student/${studentId}/gpa`, { params }),
  
  // Get grade distribution
  getGradeDistribution: (params = {}) => api.get('/grading/distribution', { params }),
  
  // Get top performers
  getTopPerformers: (params = {}) => api.get('/grading/top-performers', { params }),
  
  // Get grade history
  getGradeHistory: (studentId, params = {}) => 
    api.get(`/grading/student/${studentId}/history`, { params }),
};
